import React, { Component } from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import {
  getViewportWidth,
  getViewportHeight } from '../app/selectors'
import CollectionMedia from '../collection-media'
import CollectionRowTitles from '../collection-row-titles'
import './collection-row.css'

const mapStateToProps = (state, ownProps) => {
  return {
    vh: getViewportHeight(state),
    vw: getViewportWidth(state)
  }
}
var INCREMENT = 0

class CollectionRow extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hover: false
    }
    this.increment = INCREMENT ++
  }
  
  shouldComponentUpdate( props ) {
    if ( props.st === this.props.st || (!this.props.st)) {
      return true
    } else {
      return !!!((this.increment++) % 8)
    }
  }

  // Any hover on children images should
  // Set a generic hover state for all row elements
  onImageEnter = () => {
    this.setState({
      hover: true
    })
  }

  onImageLeave = () => {
    this.setState({
      hover: false
    })
  }

  render() {
    const { pageName, vw, vh, st, row, rowIndex, rows, match } = this.props
    const { hover } = this.state
    const isArtistPage = pageName === 'ARTIST'
    const disableFullVideo = pageName === 'HOME' | isArtistPage
    
    // const isRowTitlesVisible = isArtistPage ? (offsetTop > 120) : true
    const rowClassNames = classnames({
      'collection__row--hover': hover,
    }, 'collection__row')

    return (
      <div className={rowClassNames}>
        <CollectionMedia
          id={row.id}
          rowIndex={rowIndex}
          slug={row.slug}
          match={match}
          vw={vw}
          vh={vh}
          st={st}
          rows={rows}
          media={row.slide.get('slide_media')}
          disableFullVideo={disableFullVideo}
          mobileMedia={row.mobileImage}
          onImageEnter={this.onImageEnter}
          onImageLeave={this.onImageLeave} />
        <div className="collection__overlay">
          <CollectionRowTitles
            st={st}
            vh={vh}
            single={isArtistPage}
            title={row.title}
            subtitle={row.subtitle}
          />
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, null)(CollectionRow)



// WEBPACK FOOTER //
// ./src/components/collection-row/index.js